import { createSelector } from 'reselect';

export const landingSelector = state => state.landing;

export const landingDataSelector = createSelector(landingSelector, item => item?.data);

export const landingCoveragesSelector = createSelector(landingDataSelector, item => item?.coverages);
